import React from 'react';
import { Link } from 'react-router-dom';

const MobileBreadcrumbs = ({ interpolatedPageData }) => {
    const breadcrumb = interpolatedPageData?.breadcrumb;
    return breadcrumb?.length ? (
        <div className='scel-bread-crumb'>
            <ul>
                {breadcrumb?.map(({ name, path }, key) =>
                    key + 1 === breadcrumb?.length ? (
                        <li key={key}>{name}</li>
                    ) : (
                        <li key={key}>
                            <Link to={path}>
                                {name}
                                <span aria-hidden='true'> &gt;</span>
                            </Link>
                        </li>
                    )
                )}
            </ul>
        </div>
    ) : (
        <div className='scel-bread-crumb'>
            <ul>
                <li>
                    <Link to={'/'}>Home</Link>
                </li>
            </ul>
        </div>
    );
};

export default MobileBreadcrumbs;
